/**
 * Dead-link detection for get-long-url resolution.
 *
 * forms-service `getLongUrl` returns 410 Gone for expired/deleted/unknown form
 * links (and 404 for legacy, 403 for wiki-no-longer-public). The 410 body is a
 * JSON STRING ("URL Not Found..."), which axios surfaces as a *truthy*
 * `err.response.data`. So callers must branch on STATUS, not on the presence of
 * `data` — otherwise a dead link falls through into form rendering with all
 * fields undefined (the 2026-06-12 ViewForm bug).
 *
 * Shared by src/store/urlredirect.js, src/pages/UrlRedirect/UrlRedirect.vue, and
 * src/pages/Forms/components/ViewForm.vue. KEEP IN SYNC with the mirror in
 * cypress/node-tests/dead-link-resolution.test.js.
 */

// 410 Gone (expired/deleted/unknown), 404 (legacy not-found), 403 (wiki no longer public)
export const DEAD_LINK_STATUSES = [403, 404, 410];

/** True if the HTTP status means the link is gone/unavailable. */
export function isDeadLinkStatus(status) {
  return DEAD_LINK_STATUSES.includes(status);
}

/**
 * True if a get-long-url response (200 success or err.response on 4xx) represents
 * a dead link. Safe against undefined (getLongUrl can return undefined on other
 * errors). Branches on status only — never on the truthy error-body string.
 */
export function isDeadLinkResponse(res) {
  return !!res && isDeadLinkStatus(res.status);
}
